<div class="chart-container">
  <canvas #canvasElement id="indicators-chart" class="w-100 h-100"></canvas>
</div>
